

















import Vue from 'vue';

import EventBus from '../EventBus';

export default Vue.extend({
    name: 'UserTools',
    props: {},
    data() {
        return {
            userAuthenticated: false,
        };
    },
    methods: {
        toggleUserAuthStatus() {
            if (this.userAuthenticated) {
                console.log(`Requesting that the user be logged out.`);
                EventBus.$emit('LogOutUser');
            }
        },
        userLoggedIn() {
            this.userAuthenticated = true;
            console.log(`Updaing user authentication state to: ${this.userAuthenticated}`);
        },
        userLoggedOut() {
            this.userAuthenticated = false;
            console.log(`Updaing user authentication state to: ${this.userAuthenticated}`);
        },
        openDashbaord() {
            this.$root.$router.push({
                name: 'home',
            });
        },
        openAddresses() {
            this.$root.$router.push({
                name: 'addresses',
            });
        },
        openClinics() {
            this.$root.$router.push({
                name: 'clinics',
            });
        },
        openCases() {
            this.$root.$router.push({
                name: 'cases',
            });
        },
    },
    created() {
        EventBus.$on('UserLoggedIn', this.userLoggedIn);
        EventBus.$on('UserLoggedOut', this.userLoggedOut);
    },
    mounted() {
        console.log(`Setting initial user authentication state as: ${this.userAuthenticated}`);
    },
});
